
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 5h17.406l.313.281 4 4 .281.313V27H5V5zm2 2v18h2v-9h14v9h2V10.437l-3-3V13H10V7H7zm5 0v4h8V7h-2v2h-2V7h-4zm-1 11v7h10v-7H11z"}})])
          )
        }
      }
    